import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../js/coreRuntime.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  joinToString1cxrrlmo0chqs as joinToString,
  asSequence2phdjljfh9jhx as asSequence,
} from '../collections/_Collections.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../collections/collectionJs.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../collections/Sets.mjs';
import { reset2ep3wdzn2qbpo as reset } from '../js/regexp.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../js/charSequenceJs.mjs';
import {
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../exceptions.mjs';
import { generateSequence2pi96ci7lpz88 as generateSequence } from '../sequences/Sequences.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char__minus_impl_a2frrhw2puetaduxyd as Char__minus_impl_a2frrh,
} from '../Char.mjs';
import {
  contains2el4s70rdq4ld as contains,
  requireNonNegativeLimit1p78ioqihis7w as requireNonNegativeLimit,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
} from './Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from './StringBuilderJs.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import {
  take2rh6pen3z50h7 as take,
  mapsbvh18eqox7a as map,
} from '../sequences/_Sequences.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../collections/ArrayListJs.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../Enum.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../js/rangeTo.mjs';
import { substringiqarkczpya5m as substring } from './stringJs.mjs';
import { toInt2q8uldh7sc951 as toInt } from './numberConversions.mjs';
import { MatchNamedGroupCollection2nkf1ok7z2wgd as MatchNamedGroupCollection } from './MatchResult.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from '../collections/AbstractCollection.mjs';
import { get_indices3txodfl5wuu5j as get_indices } from '../collections/CollectionsKt.mjs';
import { AbstractList3ck35puwbp1e9 as AbstractList } from '../collections/AbstractList.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.patternEscape_1 = new RegExp('[\\\\^$*+?.()|[\\]{}]', 'g');
        this.replacementEscape_1 = new RegExp('[\\\\$]', 'g');
        this.nativeReplacementEscape_1 = new RegExp('\\$', 'g');
      }
      escape_984trb_k$(literal) {
        // Inline function 'kotlin.text.nativeReplace' call
        var pattern = this.patternEscape_1;
        // Inline function 'kotlin.js.asDynamic' call
        return literal.replace(pattern, '\\$&');
      }
      nativeEscapeReplacement_5elzqg_k$(literal) {
        // Inline function 'kotlin.text.nativeReplace' call
        var pattern = this.nativeReplacementEscape_1;
        // Inline function 'kotlin.js.asDynamic' call
        return literal.replace(pattern, '$$$$');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function Regex$findAll$lambda(match) {
  return match.next_20eer_k$();
}
var RegexClass;
function Regex() {
  if (RegexClass === VOID) {
    class $ {
      constructor(pattern, options) {
        return new.target.new_kotlin_text_Regex_w1mv1w_k$(pattern, options);
      }
      static new_kotlin_text_Regex_w1mv1w_k$(pattern, options) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.pattern_1 = pattern;
        $this.options_1 = toSet(options);
        $this.nativePattern_1 = new RegExp(pattern, toFlags(options, 'gu'));
        $this.nativeStickyPattern_1 = null;
        $this.nativeMatchesEntirePattern_1 = null;
        return $this;
      }
      static new_kotlin_text_Regex_rhjlid_k$(pattern, option) {
        Companion_getInstance();
        return this.new_kotlin_text_Regex_w1mv1w_k$(pattern, setOf(option));
      }
      static new_kotlin_text_Regex_acuq4a_k$(pattern) {
        Companion_getInstance();
        return this.new_kotlin_text_Regex_w1mv1w_k$(pattern, emptySet());
      }
      matches_evli6i_k$(input) {
        reset(this.nativePattern_1);
        var match = this.nativePattern_1.exec(toString(input));
        return !(match == null) && match.index === 0 && this.nativePattern_1.lastIndex === charSequenceLength(input);
      }
      containsMatchIn_gpzk5u_k$(input) {
        reset(this.nativePattern_1);
        return this.nativePattern_1.test(toString(input));
      }
      find_jq9i5o_k$(input, startIndex) {
        if (startIndex < 0 || startIndex > charSequenceLength(input)) {
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
        }
        return findNext(this.nativePattern_1, toString(input), startIndex, this.nativePattern_1);
      }
      find$default_xakyli_k$(input, startIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        return $super === VOID ? this.find_jq9i5o_k$(input, startIndex) : $super.find_jq9i5o_k$.call(this, input, startIndex);
      }
      findAll_98v6rh_k$(input, startIndex) {
        if (startIndex < 0 || startIndex > charSequenceLength(input)) {
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('Start index out of bounds: ' + startIndex + ', input length: ' + charSequenceLength(input));
        }
        var tmp = () => this.find_jq9i5o_k$(input, startIndex);
        return generateSequence(tmp, Regex$findAll$lambda);
      }
      findAll$default_xha0o9_k$(input, startIndex, $super) {
        startIndex = startIndex === VOID ? 0 : startIndex;
        return $super === VOID ? this.findAll_98v6rh_k$(input, startIndex) : $super.findAll_98v6rh_k$.call(this, input, startIndex);
      }
      replace_1ix0wf_k$(input, replacement) {
        if (!contains(replacement, _Char___init__impl__6a9atx(92)) && !contains(replacement, _Char___init__impl__6a9atx(36))) {
          var tmp0 = toString(input);
          // Inline function 'kotlin.text.nativeReplace' call
          var pattern = this.nativePattern_1;
          // Inline function 'kotlin.js.asDynamic' call
          return tmp0.replace(pattern, replacement);
        }
        return this.replace_dbivij_k$(input, (it) => substituteGroupRefs(it, replacement));
      }
      replace_dbivij_k$(input, transform) {
        var match = this.find$default_xakyli_k$(input);
        if (match == null)
          return toString(input);
        var lastStart = 0;
        var length = charSequenceLength(input);
        var sb = StringBuilder().new_kotlin_text_StringBuilder_wcb3z_k$(length);
        do {
          var foundMatch = ensureNotNull(match);
          sb.append_xdc1zw_k$(input, lastStart, foundMatch.get_range_ixu978_k$().get_start_iypx6h_k$());
          sb.append_jgojdo_k$(transform(foundMatch));
          lastStart = foundMatch.get_range_ixu978_k$().get_endInclusive_r07xpi_k$() + 1 | 0;
          match = foundMatch.next_20eer_k$();
        }
         while (lastStart < length && !(match == null));
        if (lastStart < length) {
          sb.append_xdc1zw_k$(input, lastStart, length);
        }
        return sb.toString();
      }
      split_p7ck23_k$(input, limit) {
        requireNonNegativeLimit(limit);
        // Inline function 'kotlin.let' call
        var it = this.findAll$default_xha0o9_k$(input);
        var matches = limit === 0 ? it : take(it, limit - 1 | 0);
        // Inline function 'kotlin.collections.mutableListOf' call
        var result = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var lastStart = 0;
        var _iterator__ex2g4s = matches.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var match = _iterator__ex2g4s.next_20eer_k$();
          result.add_utx5q5_k$(toString(charSequenceSubSequence(input, lastStart, match.get_range_ixu978_k$().get_start_iypx6h_k$())));
          lastStart = match.get_range_ixu978_k$().get_endInclusive_r07xpi_k$() + 1 | 0;
        }
        result.add_utx5q5_k$(toString(charSequenceSubSequence(input, lastStart, charSequenceLength(input))));
        return result;
      }
      toString() {
        return this.nativePattern_1.toString();
      }
    }
    initMetadataForClass($, 'Regex');
    RegexClass = $;
  }
  return RegexClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  RegexOption_IGNORE_CASE_instance = new (RegexOption())('IGNORE_CASE', 0, 'i');
  RegexOption_MULTILINE_instance = new (RegexOption())('MULTILINE', 1, 'm');
}
var RegexOption_IGNORE_CASE_instance;
var RegexOption_MULTILINE_instance;
var RegexOptionClass;
function RegexOption() {
  if (RegexOptionClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, value) {
        super(name, ordinal);
        this.value_1 = value;
      }
    }
    initMetadataForClass($, 'RegexOption');
    RegexOptionClass = $;
  }
  return RegexOptionClass;
}
function toFlags(_this__u8e3s4, prepend) {
  return joinToString(_this__u8e3s4, '', prepend, VOID, VOID, VOID, toFlags$lambda);
}
function findNext(_this__u8e3s4, input, from, nextPattern) {
  _this__u8e3s4.lastIndex = from;
  var match = _this__u8e3s4.exec(input);
  if (match == null)
    return null;
  var range = numberRangeToNumber(match.index, _this__u8e3s4.lastIndex - 1 | 0);
  return new (findNext$1())(range, match, nextPattern, input);
}
function substituteGroupRefs(match, replacement) {
  var index = 0;
  var result = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  while (index < replacement.length) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var char = charCodeAt(replacement, _unary__edvuaz);
    if (char === _Char___init__impl__6a9atx(92)) {
      if (index === replacement.length)
        throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('The Char to be escaped is missing');
      var _unary__edvuaz_0 = index;
      index = _unary__edvuaz_0 + 1 | 0;
      result.append_58al37_k$(charCodeAt(replacement, _unary__edvuaz_0));
    } else if (char === _Char___init__impl__6a9atx(36)) {
      if (index === replacement.length)
        throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Capturing group index is missing');
      if (charCodeAt(replacement, index) === _Char___init__impl__6a9atx(123)) {
        index = index + 1 | 0;
        var endIndex = readGroupName(replacement, index);
        if (index === endIndex)
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Named capturing group reference should have a non-empty name');
        if (endIndex === replacement.length || !(charCodeAt(replacement, endIndex) === _Char___init__impl__6a9atx(125)))
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$("Named capturing group reference is missing trailing '}'");
        var groupName = substring(replacement, index, endIndex);
        var tmp0_safe_receiver = get(match.get_groups_dy12vx_k$(), groupName);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.value_1;
        result.append_22ad7x_k$(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
        index = endIndex + 1 | 0;
      } else {
        var containsArg = charCodeAt(replacement, index);
        if (!(_Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false))
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Invalid capturing group reference');
        var groups = match.get_groups_dy12vx_k$();
        var endIndex_0 = readGroupIndex(replacement, index, groups.get_size_woubt6_k$());
        var groupIndex = toInt(substring(replacement, index, endIndex_0));
        if (groupIndex >= groups.get_size_woubt6_k$())
          throw IndexOutOfBoundsException().new_kotlin_IndexOutOfBoundsException_ddr8db_k$('Group with index ' + groupIndex + ' does not exist');
        var tmp2_safe_receiver = groups.get_c1px32_k$(groupIndex);
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.value_1;
        result.append_22ad7x_k$(tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs);
        index = endIndex_0;
      }
    } else {
      result.append_58al37_k$(char);
    }
  }
  return result.toString();
}
var MatchGroupClass;
function MatchGroup() {
  if (MatchGroupClass === VOID) {
    class $ {
      constructor(value) {
        this.value_1 = value;
      }
      toString() {
        return 'MatchGroup(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MatchGroup()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MatchGroup');
    MatchGroupClass = $;
  }
  return MatchGroupClass;
}
function readGroupName(_this__u8e3s4, startIndex) {
  var index = startIndex;
  $l$loop: while (index < _this__u8e3s4.length) {
    if (charCodeAt(_this__u8e3s4, index) === _Char___init__impl__6a9atx(125)) {
      break $l$loop;
    } else {
      index = index + 1 | 0;
    }
  }
  return index;
}
function get(_this__u8e3s4, name) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, MatchNamedGroupCollection()) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_chzcdl_k$('Retrieving groups by name is not supported on this platform.');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var namedGroups = tmp;
  return namedGroups.get_6bo4tg_k$(name);
}
function readGroupIndex(_this__u8e3s4, startIndex, groupCount) {
  var index = startIndex + 1 | 0;
  var groupIndex = Char__minus_impl_a2frrh(charCodeAt(_this__u8e3s4, startIndex), _Char___init__impl__6a9atx(48));
  $l$loop_0: while (true) {
    var tmp;
    if (index < _this__u8e3s4.length) {
      var containsArg = charCodeAt(_this__u8e3s4, index);
      tmp = _Char___init__impl__6a9atx(48) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57) : false;
    } else {
      tmp = false;
    }
    if (!tmp) {
      break $l$loop_0;
    }
    var newGroupIndex = imul(groupIndex, 10) + Char__minus_impl_a2frrh(charCodeAt(_this__u8e3s4, index), _Char___init__impl__6a9atx(48)) | 0;
    if (0 <= newGroupIndex ? newGroupIndex < groupCount : false) {
      groupIndex = newGroupIndex;
      index = index + 1 | 0;
    } else {
      break $l$loop_0;
    }
  }
  return index;
}
function toFlags$lambda(it) {
  return it.value_1;
}
function hasOwnPrototypeProperty($this, o, name) {
  // Inline function 'kotlin.js.unsafeCast' call
  return Object.prototype.hasOwnProperty.call(o, name);
}
function advanceToNextCharacter($this, index) {
  if (index < get_lastIndex($this.$input_1)) {
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var code1 = $this.$input_1.charCodeAt(index);
    if (55296 <= code1 ? code1 <= 56319 : false) {
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      var code2 = $this.$input_1.charCodeAt(index + 1 | 0);
      if (56320 <= code2 ? code2 <= 57343 : false) {
        return index + 2 | 0;
      }
    }
  }
  return index + 1 | 0;
}
var findNext$1$groups$1Class;
function findNext$1$groups$1() {
  if (findNext$1$groups$1Class === VOID) {
    class $ extends AbstractCollection() {
      constructor($match, this$0) {
        return new.target.new_kotlin_text__no_name_provided___no_name_provided__ee22tr_k$($match, this$0);
      }
      static new_kotlin_text__no_name_provided___no_name_provided__ee22tr_k$($match, this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.$match_1 = $match;
        $box.this$0__1 = this$0;
        return this.new_kotlin_collections_AbstractCollection_s1tlv0_k$($box);
      }
      get_size_woubt6_k$() {
        return this.$match_1.length;
      }
      iterator_jk1svi_k$() {
        var tmp = asSequence(get_indices(this));
        return map(tmp, (it) => this.get_c1px32_k$(it)).iterator_jk1svi_k$();
      }
      get_c1px32_k$(index) {
        // Inline function 'kotlin.js.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = this.$match_1[index];
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = new (MatchGroup())(tmp0_safe_receiver);
        }
        return tmp;
      }
      get_6bo4tg_k$(name) {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_elvis_lhs = this.$match_1.groups;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Capturing group with name {' + name + '} does not exist. No named capturing group was defined in Regex');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var groups = tmp;
        if (!hasOwnPrototypeProperty(this.this$0__1, groups, name))
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Capturing group with name {' + name + '} does not exist');
        var value = groups[name];
        var tmp_0;
        if (value == undefined) {
          tmp_0 = null;
        } else {
          tmp_0 = new (MatchGroup())((!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [MatchNamedGroupCollection()]);
    findNext$1$groups$1Class = $;
  }
  return findNext$1$groups$1Class;
}
var findNext$1$groupValues$1Class;
function findNext$1$groupValues$1() {
  if (findNext$1$groupValues$1Class === VOID) {
    class $ extends AbstractList() {
      constructor($match) {
        return new.target.new_kotlin_text__no_name_provided___no_name_provided__gwoum9_k$($match);
      }
      static new_kotlin_text__no_name_provided___no_name_provided__gwoum9_k$($match, $box) {
        if ($box === VOID)
          $box = {};
        $box.$match_1 = $match;
        return this.new_kotlin_collections_AbstractList_7zpyyf_k$($box);
      }
      get_size_woubt6_k$() {
        return this.$match_1.length;
      }
      get_c1px32_k$(index) {
        // Inline function 'kotlin.js.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_elvis_lhs = this.$match_1[index];
        return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      }
    }
    initMetadataForClass($);
    findNext$1$groupValues$1Class = $;
  }
  return findNext$1$groupValues$1Class;
}
var findNext$1Class;
function findNext$1() {
  if (findNext$1Class === VOID) {
    class $ {
      constructor($range, $match, $nextPattern, $input) {
        this.$range_1 = $range;
        this.$match_1 = $match;
        this.$nextPattern_1 = $nextPattern;
        this.$input_1 = $input;
        this.range_1 = $range;
        var tmp = this;
        tmp.groups_1 = findNext$1$groups$1().new_kotlin_text__no_name_provided___no_name_provided__ee22tr_k$($match, this);
        this.groupValues__1 = null;
      }
      get_range_ixu978_k$() {
        return this.range_1;
      }
      get_value_j01efc_k$() {
        // Inline function 'kotlin.js.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = this.$match_1[0];
        return ensureNotNull(tmp$ret$0);
      }
      get_groups_dy12vx_k$() {
        return this.groups_1;
      }
      get_groupValues_rkv314_k$() {
        if (this.groupValues__1 == null) {
          var tmp = this;
          tmp.groupValues__1 = findNext$1$groupValues$1().new_kotlin_text__no_name_provided___no_name_provided__gwoum9_k$(this.$match_1);
        }
        return ensureNotNull(this.groupValues__1);
      }
      next_20eer_k$() {
        return findNext(this.$nextPattern_1, this.$input_1, this.$range_1.isEmpty_y1axqb_k$() ? advanceToNextCharacter(this, this.$range_1.get_start_iypx6h_k$()) : this.$range_1.get_endInclusive_r07xpi_k$() + 1 | 0, this.$nextPattern_1);
      }
    }
    initMetadataForClass($);
    findNext$1Class = $;
  }
  return findNext$1Class;
}
function RegexOption_IGNORE_CASE_getInstance() {
  static_init();
  return RegexOption_IGNORE_CASE_instance;
}
//region block: exports
export {
  RegexOption_IGNORE_CASE_getInstance as RegexOption_IGNORE_CASE_getInstance2fmuzo7a7o03f,
  Companion_getInstance as Companion_getInstance3che4h0wuq1kd,
  Regex as Regexxgw0gjiagf4z,
};
//endregion

//# sourceMappingURL=regex.mjs.map
